<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the LVB specific component for rendering the Duty activity start line (first line in a block)    -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row dense>
    <v-col cols="2">{{ time(dutyActivity.fromMinutesAfterMidnight) }}</v-col>
    <v-col cols="2">{{ dutyStopsById[dutyActivity.startStopIdFk].shortname }}</v-col>
    <v-col cols="5">{{ dutyStopsById[dutyActivity.startStopIdFk].longname }}</v-col>
    <v-col cols="3">{{ activityShort }}</v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityStartDefault',
  components: {},
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    isParent: { type: Boolean, default: false },
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    activityShort() {
      if (this.isParent) return '';
      return ['EinW', 'E', 'ÜWegZ', 'BezArb', 'SE', 'PauHin', 'UNBPAU', 'MITF', 'PauRück', 'A', 'AusW'].includes(this.dutyActivity.activityShortname)
        ? this.dutyActivity.activityShortname
        : '';
    },
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
